import { Box, Divider, Grid } from '@mui/material'
import React from 'react'

import { DrawerUserDetail } from 'components/navigation/Nav/DrawerUserDetail'
import { colors } from 'mui-theme/theme'
import theme from 'theme'
import { UserSessionInfo } from 'types/api/user/session'
import { getUserDisplayName } from 'utils/user'

export const DrawerUserInfo: React.FC<{
  companyDisplayName: string
  currentTeamName: string
  session: UserSessionInfo
}> = ({ companyDisplayName, currentTeamName, session, ...rest }) => {
  return (
    <Box {...rest}>
      <Divider sx={{ backgroundColor: colors.primary[200] }} />
      <Grid
        container
        css={{
          color: theme.colors.white[0],
          padding: theme.space[4]
        }}
        rowSpacing={1}
      >
        {getUserDisplayName(session) && (
          <DrawerUserDetail
            iconName="solidUser"
            text={getUserDisplayName(session)}
          />
        )}
        {currentTeamName && (
          <DrawerUserDetail iconName="solidUserGroup" text={currentTeamName} />
        )}
        {companyDisplayName && (
          <DrawerUserDetail
            iconName="solidBuilding"
            text={companyDisplayName}
          />
        )}
      </Grid>
    </Box>
  )
}
